<template>
  <div class="CorrectPolyPhoneModal">
    <el-dialog
      title="[ā] 多音字 "
      :visible.sync="visible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="handleOpen"
      width="30%"
    >
      <div class="contentBox">
        <span v-for="(option, optionIndex) in characterArr" :key="optionIndex">
          <span v-if="option.cha === ' '">{{ option.cha }}</span>
          <template v-if="pronunciations[optionIndex].length > 1">
            <span v-if="option.pinyin" class="pinyinBox">
              <span class="pinyin">{{ option.pinyin }}</span>
              <span @click="handleDeletePinYin(optionIndex)"
                ><i class="el-icon-error"></i
              ></span>
            </span>
            <el-dropdown
              @command="handleCommand(optionIndex, $event)"
              :show-timeout="0"
            >
              <b v-if="option.pinyin" class="el-dropdown-link"
                >【{{ option.cha }}】</b
              >
              <b v-else class="el-dropdown-link"> {{ option.cha }}</b>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, itemIndex) in pronunciations[optionIndex]"
                  :key="itemIndex"
                  :command="item"
                >
                  <i v-if="option.pinyin === item" class="el-icon-check"></i>
                  {{ item }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template v-else>
            <span>{{ option.cha }}</span>
          </template>
        </span>
      </div>
      <div class="footer">
        <el-button style="width: 80px" type="primary" @click="handleConfirm"
          >确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { pinyin } from "pinyin-pro";

export default {
  name: "CorrectPolyPhoneModal",
  props: {
    inputValArr: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      selectedPronunciation: "",
      pronunciations: [],
      characterArr: [],
    };
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.polyPhone.polyPhoneModalVisible;
      },
      set(value) {
        this.$store.commit("polyPhone/setData", {
          key: "polyPhoneModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("polyPhone", ["setData"]),
    handleDeletePinYin(index) {
      this.characterArr[index].pinyin = "";
    },
    getPronunciations(item) {
      const pinyinList = pinyin(item, {
        multiple: true,
        toneType: "num",
      });
      this.pronunciations.push(pinyinList.split(" "));
    },
    handleOpen() {
      this.clearContent();
      this.characterArr = this.inputValArr;
      this.characterArr.forEach((item) => {
        this.getPronunciations(item.cha);
      });
    },
    handleConfirm() {
      const inputText = this.characterArr
        .map((item, index) => {
          if (item.pinyin !== "") {
            if (index % 2 === 0) {
              return `<b style='color: #10689c;'> [${item.pinyin}]${item.cha} </b>`;
            } else {
              return `<b style='color: #10689c;background: transparent;'> [${item.pinyin}]${item.cha} </b>`;
            }
          } else {
            if (item.cha === " ") {
              return "&nbsp;";
            } else {
              return item.cha;
            }
          }
        })
        .join("");
      // 回显
      this.$emit("refreshInputVal", inputText);
      this.setData({ key: "polyPhoneModalVisible", value: false });
    },
    handleCommand(index, a) {
      if (this.characterArr[index].pinyin === a) {
        this.characterArr[index].pinyin = "";
      } else {
        this.characterArr[index].pinyin = a;
      }
    },
    clearContent() {
      (this.selectedPronunciation = ""),
        (this.pronunciations = []),
        (this.characterArr = []);
    },
  },
};
</script>

<style lang="scss" scoped>
//.CorrectPolyPhoneModal {
::v-deep .el-dialog {
  min-width: 880px;
  min-height: 650px;
  position: relative;
  margin-top: 15vh !important;
}

.contentBox {
  padding: 10px;
  min-height: 500px;
  font-size: 16px;
  background: #fafafa;
  letter-spacing: 0.1em;
  line-height: 30px;

  .pinyinBox {
    background: #10689c;
    border-radius: 3px;

    .pinyin {
      color: #ffffff;
      padding-left: 10px;
    }

    .el-icon-error {
      color: #f0f2fa;
      margin: 0 3px;
      cursor: pointer;
    }
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #10689c;
  }
}

.footer {
  position: absolute;
  text-align: center;
  bottom: 20px;
  right: 50px;
}

//}
</style>
